import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '2020中国·重庆国际康养盛典暨康养创新项目发布会';

const route: RouteConfig = {
  path: '/20200108GJKYSD',
  name: '20200108GJKYSD',
  component: () => import('./Home.vue'),
  redirect: '/20200108GJKYSD/first',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'first',
      component: () => import('./First.vue'),
      name: 'first',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'second',
      component: () => import('./Second.vue'),
      name: 'second',
      meta: {
        title: PAGE_TITLE,
      },
    },
        {
      path: 'detail',
      component: () => import('./DetailPage.vue'),
      name: 'DetailPage',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
